import { render, staticRenderFns } from "./MailService.vue?vue&type=template&id=486af3a1"
import script from "./MailService.vue?vue&type=script&lang=ts"
export * from "./MailService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports